import { render } from "./Efetivadas.vue?vue&type=template&id=3ebd2e4c&scoped=true"
import script from "./Efetivadas.vue?vue&type=script&lang=js"
export * from "./Efetivadas.vue?vue&type=script&lang=js"

import "./Efetivadas.vue?vue&type=style&index=0&id=3ebd2e4c&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ebd2e4c"]])

export default __exports__